import React, { Fragment, useState, useContext, useEffect } from 'react';
import {Link} from 'react-router-dom';
import {
    Paper,
    Grid,
    Button,
    Typography
} from '@material-ui/core';

import { useStyles } from '../styles/Styles';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import Header from '../components/header/Header';
//import ActivateCardIcon from '../images/icons/ActivateATMCardIcon.png';
//import ChangePINIcon from '../images/icons/ChangePINIcon.png';
import ActivateCardIcon from '../images/icons/ActivateFlexiCard.png';
import ChangePINIcon from '../images/icons/ChangeFlexiCardPin.png';

const AccountServicesMain = () => {

    const classes = useStyles();
    const documentUploadContext = useContext(DocumentUploadContext);
    const {
    } = documentUploadContext;

    return (
        <div>
            <Header page={1} />
            <div className={classes.banner}>
                <Grid container spacing={2} alignItems='center' justify='center'>
                   {/*  <Grid item md={4}>
                        <div className={classes.accountServicesLinkCenter}>
                            <img src={DocumentUploadIcon} style={{ width: '350px' }}/>
                            <Link className={classes.accountServicesLink} to='./DocumentUpload/'>Document Upload</Link>
                        </div>
                    </Grid> */}
                    <Grid item md={4} sm={12} xs={12}>
                        <div className={classes.accountServicesLinkCenter}>
                            
            <a href={`${process.env.REACT_APP_URL}ActivateCard/`}>
            <img src={ActivateCardIcon} style={{ width: '350px' }} />                            
            </a>
                            <br />
                            <a href={`${process.env.REACT_APP_URL}ActivateCard/`} className={classes.accountServicesLink}>
                            Nominate Flexi Card PIN                        
                                </a>
                        </div>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <div className={classes.accountServicesLinkCenter}>
                            
                            <a href={`${process.env.REACT_APP_URL}ChangePIN/`}>
                                <img src={ChangePINIcon} style={{ width: '350px' }} />
                            </a>
                            <br />                            
                            <a href={`${process.env.REACT_APP_URL}ChangePIN/`} className={classes.accountServicesLink}>
                            Change Flexi Card PIN                    
                                </a>
                        </div>
                    </Grid>
                </Grid>
                <br /> <br />
            </div>
        </div>   
    );
};

export default AccountServicesMain;
